// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    path: string;
    // bunzl custom code added style override
    extendedStyles?: ButtonPresentationProps;
}

type Props = OwnProps;

const addToCartButton: ButtonPresentationProps = {};

const StoreVariantsButton: FC<Props> = ({ path, extendedStyles }) => {
    // bunzl custom code added style override
    const styles = useMergeProps(addToCartButton, extendedStyles);
    const history = useHistory();

    const productDetailPath = () => {
        history.push(path);
    };

    return (
        <Button {...styles} onClick={productDetailPath}>
            {translate("Select options")}
        </Button>
    );
};

export default StoreVariantsButton;
